<template>
  <div class="routes">
    <div class="map-wrapper">
      <div class="over-map-content">
        <v-btn
          color="primary"
          class="mr-5 mb-4"
          @click.native="drawingRoute = true"
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <routes-map
        :routes="routes"
        :drawing-route="drawingRoute"
        @line-string-created="createRoute" @line-string-clicked="openRouteDialog"
      ></routes-map>
    </div>
    <v-dialog
      v-model="dialog"
      :width="620"
    >
      <v-card>
        <v-card-title primary-title>
          <div class="headline">
            <v-icon>navigation</v-icon>
            Ruta {{ selectedRouteName }}
          </div>
          <v-spacer></v-spacer>
          <v-menu offset-y bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="removeRoute">
                <v-list-tile-action>
                  <v-icon color="primary">delete</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    Eliminar Ruta
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="selectedRouteName"
                  label="Nombre"
                  prepend-icon="navigation"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-autocomplete
                  :items="vehicles"
                  v-model="selectedRouteVehicles"
                  item-text="plate"
                  item-value="_id"
                  multiple
                  label="Vehículos"
                  prepend-icon="directions_car"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            flat
            @click="updateRoute"
            :loading="updatingRoute"
          >Guardar</v-btn>
          <v-btn
            flat
            @click.native="dialog = false"
          >Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>

<script>
import { find } from 'lodash'

import Map from '@/components/Maps/Routes'
import Snackbar from '@/components/Snackbar'

export default {
  name: 'routes',
  data: function () {
    return {
      updatingRoute: false,
      drawingRoute: false,
      selectedRouteId: false,
      selectedRouteName: 'Nombre de la Ruta',
      selectedRouteVehicles: [],
      dialog: false
    }
  },
  computed: {
    vehicles: function () {
      return this.$store.state.Routes.vehicles
    },
    shapes: function () {
      return this.$store.state.Routes.shapes
    },
    routes: function () {
      const routes = []
      for (const shape of this.shapes) {
        if (shape.geometry.type === 'LineString') {
          routes.push(shape)
        }
      }
      return routes
    }
  },
  components: {
    'routes-map': Map,
    'snackbar': Snackbar
  },
  created: async function () {
    try {
      await this.$store.dispatch('Routes/fetchShapes')
      await this.$store.dispatch('Routes/fetchVehicles')
    } catch (e) {
      console.error(e)
      this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor')
    }
  },
  methods: {
    openRouteDialog: function (routeId) {
      const route = find(this.routes, { _id: routeId })
      this.selectedRouteId = route._id
      this.selectedRouteName = route.name
      this.selectedRouteVehicles = route.vehicles
      this.dialog = true
    },
    createRoute: async function (lineString) {
      this.drawingRoute = false
      const route = {
        geometry: lineString,
        name: 'Sin Título',
        vehicles: []
      }
      try {
        await this.$store.dispatch('Routes/createShape', {
          shape: route
        })
      } catch (e) {
        console.error(e)
        return this.$refs.snackbar.open('error', 'Ocurrió un error mientras se creaba la ruta')
      }
      this.$refs.snackbar.open('success', 'Ruta creada')
    },
    updateRoute: async function () {
      this.updatingRoute = true
      try {
        await this.$store.dispatch('Routes/updateShape', {
          shapeId: this.selectedRouteId,
          shape: {
            name: this.selectedRouteName,
            vehicles: this.selectedRouteVehicles
          }
        })
      } catch (e) {
        this.updatingRoute = false
        console.error(e)
        return this.$refs.snackbar.open('error', 'Ocurrió un error mientras se actualizaba la ruta')
      }
      this.updatingRoute = false
      this.dialog = false
      this.selectedRouteId = false
      this.selectedRouteName = ''
      this.selectedRouteVehicles = []
      this.$refs.snackbar.open('success', 'Ruta actualizada')
    },
    removeRoute: async function () {
      const shapeId = this.selectedRouteId
      try {
        await this.$store.dispatch('Routes/removeShape', {
          shapeId
        })
      } catch (e) {
        console.error(e)
        return this.$refs.snackbar.open('error', 'Ocurrió un error mientras se eliminaba la ruta')
      }
      this.dialog = false
      this.selectedRouteId = false
      this.selectedRouteName = false
      this.selectedRouteVehicles = []
      this.$refs.snackbar.open('success', 'Ruta eliminada')
    }
  }
}
</script>

<style lang="sass" scoped>
.routes
  height: 100%
  margin: 0
  padding: 0
.map-wrapper
  position: relative
.over-map-content
  position: absolute
  z-index: 1
.routes-map
  height: calc(100vh - 66px)
  padding: 0
  margin: 0
</style>



// WEBPACK FOOTER //
// src/components/Routes.vue